import { h } from 'preact';

// Absolutely-positioned SVG reticle at the current controller aim
// point. Purely presentational. The parent owns the {x, y} state and
// the `snapped` flag, derived from the raycast result.
//
// When snapped to a card, the reticle grows slightly and its stroke
// brightens to make the "this is locked" state unambiguous without
// adding a separate UI badge.

export function ControllerAimReticle({ x, y, snapped = false, visible = true }) {
  if (!visible || typeof x !== 'number' || typeof y !== 'number') return null;
  const size = snapped ? 40 : 28;
  const half = size / 2;
  const stroke = snapped ? '#fde68a' : '#fafafa';
  const strokeWidth = snapped ? 2.5 : 1.5;
  return h(
    'div',
    {
      'aria-hidden': 'true',
      style: {
        position: 'fixed',
        left: `${x - half}px`,
        top: `${y - half}px`,
        width: `${size}px`,
        height: `${size}px`,
        pointerEvents: 'none',
        zIndex: 9998,
        transition: 'width 90ms ease-out, height 90ms ease-out',
      },
    },
    h(
      'svg',
      { width: size, height: size, viewBox: `0 0 ${size} ${size}` },
      h('circle', {
        cx: half, cy: half, r: half - strokeWidth,
        fill: 'none', stroke, 'stroke-width': strokeWidth,
        opacity: snapped ? 0.95 : 0.75,
      }),
      h('circle', {
        cx: half, cy: half, r: 2,
        fill: stroke, opacity: snapped ? 1 : 0.85,
      }),
      h('line', {
        x1: half, y1: 2, x2: half, y2: 8,
        stroke, 'stroke-width': strokeWidth, opacity: 0.9,
      }),
      h('line', {
        x1: half, y1: size - 8, x2: half, y2: size - 2,
        stroke, 'stroke-width': strokeWidth, opacity: 0.9,
      }),
      h('line', {
        x1: 2, y1: half, x2: 8, y2: half,
        stroke, 'stroke-width': strokeWidth, opacity: 0.9,
      }),
      h('line', {
        x1: size - 8, y1: half, x2: size - 2, y2: half,
        stroke, 'stroke-width': strokeWidth, opacity: 0.9,
      }),
    ),
  );
}

export default ControllerAimReticle;
